import React, { useEffect, useState } from 'react';
import { Upload, Button, Input, Form, message, Row, Col, Card, Select } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { ComponentTitle, StledSpin } from '../custom-components';
import { TaskRow } from '../zype/styled-components';
import csv from 'csvtojson';
import { RcFile } from 'antd/es/upload';
import { authAxios, getEmailFromSessionStorage } from "../utils/session_utils";

// Layout options come from the backend; fallback used until the fetch resolves.
const DEFAULT_LAYOUT = "tamron-hall";
const FALLBACK_LAYOUT_OPTIONS = [{ value: DEFAULT_LAYOUT, label: "Tamron Hall" }];

interface LayoutOption {
    value: string;
    label: string;
}

const UploadPrograms: React.FC = () => {
    const [title, setTitle] = useState<string>('');
    const [postSheetLayout, setPostSheetLayout] = useState<string>(DEFAULT_LAYOUT);
    const [fileList, setFileList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [layoutOptions, setLayoutOptions] = useState<LayoutOption[]>(FALLBACK_LAYOUT_OPTIONS);

    useEffect(() => {
        const fetchLayouts = async () => {
            try {
                const response = await authAxios({
                    method: "GET",
                    url: `${process.env.REACT_APP_BACK_END_API}/auto-podder/post-sheet-layouts`,
                    headers: { "Content-Type": "application/json" },
                });
                const layouts = response.data?.layouts || [];
                if (layouts.length > 0) {
                    setLayoutOptions(
                        layouts.map((l: { key: string; displayName: string }) => ({
                            value: l.key,
                            label: l.displayName,
                        }))
                    );
                }
            } catch (err) {
                console.error("Failed to load post-sheet layouts; using fallback", err);
            }
        };
        fetchLayouts();
    }, []);

    const uploadFile = async () => {
        const formData = new FormData();
        formData.append("file1", fileList[0] as RcFile);
        formData.append("title", title);
        formData.append("post_sheet_layout", postSheetLayout);

        try {
            setIsLoading(true);
            const config = {
                method: "POST",
                url: `${process.env.REACT_APP_BACK_END_API}/auto-podder/upload-program`,
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            };
            const response = await authAxios(config);
            console.log('Response:', response.data);
            if (!response.data.error) {
                message.success(response.data.message);
            } else {
                message.error(response.data.error);
            }
        } catch (error: any) {
            console.log('Error:', error);
            console.error(error.response.data.error);
            message.error(error.response?.data?.error || 'Something went wrong during upload.');
        } finally {
            setIsLoading(false);
            setFileList([]);
            setTitle('');
            setPostSheetLayout(DEFAULT_LAYOUT);
        }
    }

    const handleSubmit = async () => {
        if (!title || fileList.length === 0) {
            message.error('Please provide a title and upload a CSV file.');
            return;
        }
        if (fileList.length > 1) {
            message.error('Please upload only one CSV file.');
            return;
        }
        const file = fileList[0];
         // Validate file type
        if (file.type !== 'text/csv') {
            message.error('Please upload a valid CSV file.');
            return;
        }

        await uploadFile();
        
    };


    const beforeUpload = (file: any) => {
		// console.log("beforeUpload", { fileList, file });
		// fileList.push(file);
		setFileList([file]);
        // setFile(file);
		return false;
	};

    return (
        <StledSpin spinning={isLoading}>
        <Row justify="center">
            <Col>
                <ComponentTitle>Upload Program Structure File</ComponentTitle>
            </Col>
        </Row>
        <TaskRow>
            <Card
                actions={[
                    <Button key="import-btn" type="primary" onClick={handleSubmit}>
                        Submit
                    </Button>,
                ]}
                style={{ width: '50%' }}
			>
            <Form layout="vertical" onFinish={handleSubmit}>
                <Form.Item label="Title" required>
                    <Input value={title} onChange={(e) => setTitle(e.target.value)} />
                </Form.Item>
                <Form.Item label="Post Sheet Layout" required>
                    <Select
                        value={postSheetLayout}
                        onChange={(value) => setPostSheetLayout(value)}
                        options={layoutOptions}
                    />
                </Form.Item>
                <Form.Item label="Upload CSV" required>
                    <Upload
                        fileList={fileList}
                        accept=".csv"
                        beforeUpload={beforeUpload}
                        onRemove={() => setFileList([])}
                    >
                        <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                   
                </Form.Item>
            </Form>
            </Card>
        </TaskRow>
        </StledSpin>
    );
};

export default UploadPrograms;